<template>
	<div class="specialists">
		<!-- BIG SLOGAN -->
		<div class="container">
      <crowd-or-rais :showStar="false"></crowd-or-rais>
			<h1 class="big-slogan-blue">{{ $t("profile.slogan") }}</h1>
			<h2 class="mb-50">{{ $t("profile.sloganTwo") }}</h2>
		</div><!-- .container -->

		<!-- FILTERS -->
		<div class="container filters">
      <search></search>
		</div><!-- .container .mb-50 -->

		<!-- SPECIALISTS LISTING -->
		<div class="container">
			<div class="all-categories mb-30">
				<strong>{{ $t("specialists") }}</strong> {{ search.profession }}
			</div>
			<div class="row">
        <specialist-tile v-for="(specialist, index) in specialists" :key="specialist.id" :specialist="specialist" :size="tileSize(index)"></specialist-tile>
      </div>
			<button v-if="!isLast" type="button" :disabled="show_loader" @click="showMore()" class="btn btn-lg button-more-crowd">
        <span v-if="!show_loader">{{ $t("showMore") }} </span>
        <clip-loader :loading="show_loader" :color="'#fff'" :size="'15px'"></clip-loader>
      </button>
		</div><!-- .container -->

    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
// API
import usersApi from '@/api/v1/user';
// Components
import SpecialistTile from '@/components/Profile/Tiles/Specialist';
import CrowdOrRais from '@/components/CrowdOrRais';
import Search from '@/components/Profile/Search';
import ClipLoader from 'vue-spinner/src/ClipLoader';

let end = 0;
function tileSize(index) {
  if (index >= end || (index - 1) >= end) {
    end = end === index ? end : end += 5;
    return 'col-md-6';
  }
  return 'col-md-4';
}

export default {
  components: { SpecialistTile, CrowdOrRais, Search, ClipLoader },
  data() {
    return {
      specialists: [],
      page: 1,
      isLast: true,
    };
  },
  computed: {
    search() {
      return {
        country_id: this.$route.query.country_id || '',
        city: this.$route.query.city,
        profession_id: this.$route.query.profession_id || '',
        profession: this.$route.query.profession || '',
      };
    },
  },
  methods: {
    getSpecialists() {
      usersApi.search(this.search, (response) => {
        this.show_loader = false;
        this.specialists.push(...response.specialists);
        this.isLast = response.is_last;
      }, this.page);
    },
    showMore() {
      this.show_loader = true;
      this.page += this.page;
      this.getSpecialists();
    },
    tileSize,
  },
  created() {
    end = 0;
    this.getSpecialists();
  },
  watch: {
    $route() {
      end = 0;
      this.specialists = [];
      this.page = 1;
      this.isLast = true;
      this.getSpecialists();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?0be1d318